import React from 'react';

const Hero = ({ onOpenForm }) => {
  return (
    <section className="relative overflow-hidden">
      {/* Overlay com degradê */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary-medium to-transparent z-10"></div>
      
      {/* Imagem de fundo */}
      <div className="absolute inset-0">
        <img 
          src={require('../assets/images/hero/imageminicial.PNG')} 
          alt="Dr. Guthyerres Carvalho atendendo" 
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Conteúdo */}
      <div className="container mx-auto px-4 py-32 relative z-20">
        <div className="max-w-xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-sans font-bold mb-6 leading-tight text-neutral-lightest">
            Dr. Guthyerres Carvalho
          </h1>
          <p className="text-xl mb-8 font-light leading-relaxed text-neutral-lightest">
            Tenha segurança para trabalhar com hormônios e emagrecimento entregando resultados consistentes com segurança baseado nas melhores evidências.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <a 
              href="https://pt.surveymonkey.com/r/R7CD6CV"
              target="_blank" rel="noopener noreferrer"
              className="bg-secondary hover:bg-secondary-light text-primary-dark font-bold py-3 px-8 rounded-full text-center transition-colors duration-300 shadow-soft"
            >
              Inscrever-se na Mentoria
            </a>
            <a 
              href="https://linktr.ee/DrGuthyerrescarvalho?fbclid=PAZXh0bgNhZW0CMTEAAafF8h6c4PqQZ6cSJHn3B1X5SuklnJX5RWx5FSWT40tJCZ2q1g5iIjpNyQTi2Q_aem_KCsT9VxDXqgyRVYaVvnEig" 
              target="_blank" rel="noopener noreferrer"
              className="bg-transparent hover:bg-white/10 border-2 border-secondary text-secondary hover:text-secondary-light font-bold py-3 px-8 rounded-full text-center transition-colors duration-300"
            >
              Sou paciente
            </a>
          </div>
        </div>
      </div>
      
      {/* Indicadores de navegação */}
      <div className="absolute bottom-8 left-0 right-0 flex justify-center space-x-2 z-20">
        <span className="w-2 h-2 rounded-full bg-neutral-lightest opacity-100"></span>
        <span className="w-2 h-2 rounded-full bg-neutral-lightest opacity-50"></span>
      </div>
    </section>
  );
};

export default Hero;


